module.exports = __webpack_public_path__ + "img/img_level_12.3d75e710.png";